import { render, staticRenderFns } from "./product_hyper.vue?vue&type=template&id=6765204c"
import script from "./product_hyper.vue?vue&type=script&lang=js"
export * from "./product_hyper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductHyperElements: require('/root/containers/hermes_eshop/components/core/productHyperElements.vue').default})
